export interface Kursant {
    key?: string,
    isActive: boolean,
    id_kursanci: string,    
    adres: string,
    data_urodzenia: string,
    e_mail: string,
    haslo: string,
    imie: string,
    imiona_rodzicow: string,
    kod: string,
    login: string,
    miejsce_urodzenia: string,
    miejscowosc: string,
    nazwisko: string,
    telefon_dom: string,
    telefon_kom: string,
    telefon_praca: string,
    uwagi: string,
    grupaId: GrupyIds[],
}

export class GrupyIds {
    nazwa: string;

}



// WEBPACK FOOTER //
// ./src/app/services/kursant.ts